export default function({ app, redirect, error }) {
  if (app.$auth.user.id !== 1 || app.$auth.user.role !== 1) {
    error({ statusCode: 404 });
  }
}